import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PersonApi } from '../+api';
import { LoopInterface } from '../+models';

@Injectable({
  providedIn: 'root',
})
export class LoopService {
  constructor(private personApi: PersonApi) {}

  getAllForUser(userId: number): Observable<LoopInterface[]> {
    return this.personApi.getData(userId, 'loops').pipe(map((res: { loops: LoopInterface[] }) => res.loops));
  }
}
